import { render } from "./About.vue?vue&type=template&id=2c720f40&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=2c720f40&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dominika\\Documents\\programowanie\\stonki\\nidomika.github.io\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c720f40"]])

export default __exports__